import React from 'react';

function Footer() {
  return (
    <div className='ui vertical footer segment'>
      <div className='ui center aligned container'>
        <div className='ui section divider'></div>
        <div className='ui horizontal small divided link list'>
          <a
            className='item'
            href='https://hraf.yale.edu'
            target='_blank'
            rel='noopener noreferrer'
          >
            HRAF Home
          </a>
          <a
            className='item'
            href='https://ehrafworldcultures.yale.edu'
            target='_blank'
            rel='noopener noreferrer'
          >
            eHRAF World Cultures
          </a>
          <a
            className='item'
            href='https://ehrafarchaeology.yale.edu'
            target='_blank'
            rel='noopener noreferrer'
          >
            eHRAF Archaeology
          </a>
          <a
            className='item'
            href='https://hraf.yale.edu/contact'
            target='_blank'
            rel='noopener noreferrer'
          >
            Contact Us
          </a>
        </div>
        <div className='footer-element'>
          © 2020 HRAF Cross Cultural Concordance
        </div>
      </div>
    </div>
  );
}

export default Footer;
